export default {
    getRefinedContent: state => {
      return state.refinedByLaw;
    }
  };
   